module.exports = __webpack_public_path__ + "img/0Q3B0162_L_Foamcore_MockedUp.70cbf15c.jpg";